/**
 * CR070: Flyer Diagnostics v2 Admin Page
 * Moved from Home screen to Admin Console
 */

import { AdminLayout } from "@/components/admin/AdminLayout";
import { useAuth } from "@/contexts/AuthContext";
import { FlyerDiagnosticsPanel } from "@/components/admin/flyer-v2/FlyerDiagnosticsPanel";
import { Loader2, ShieldAlert } from "lucide-react";

export default function FlyerDiagnosticsV2() {
  const { isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      </AdminLayout>
    );
  }

  if (!isAdmin) {
    return (
      <AdminLayout>
        <div className="flex flex-col items-center justify-center h-64 gap-3">
          <ShieldAlert className="h-10 w-10 text-destructive/60" />
          <h2 className="text-xl font-semibold text-destructive">Not Authorized</h2>
          <p className="text-muted-foreground text-sm">
            Admin access is required to view this page.
          </p>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Flyer Diagnostics v2</h1>
          <p className="text-muted-foreground">
            Process flyer PDFs and images through the OCR + AI pipeline
          </p>
        </div>
        
        <FlyerDiagnosticsPanel />
      </div>
    </AdminLayout>
  );
}
